<template>
    <div
            class="property-listing-card-favorite-button float-right mr-xl-2"
            :data-hideOnBalloon="hideOnBalloon"
            :data-displayButtonIconOnly="displayButtonIconOnly"
    >
        <div
                :class="{'favorite-loading': favoriteIsLoading}"
        >
            <b-button
                variant="link"
                class="button"
                @click.stop.prevent="handleFavClick"
                :disabled="favoriteIsLoading"
            >
                <i
                    class="fa-heart fav-btn"
                    :class="[
                        isFavorite ? 'active fas' : 'far',
                        favoriteIsLoading ? 'pointer-events-none' : '',
                    ]"
                />
            </b-button>
        </div>
    </div>
</template>

<script>
    import './PropertyListingCardFavoriteButton.scss';
    import AppResource from "@milestoneslabs/milestones-js-engine/src/Data/AppResource";
    import GetPropertyInstanceMixin from "../../mixins/GetPropertyInstanceMixin";
    import FavoriteButtonMixin, {
        PROPERTY_DETAILS_FAVORITE_ACTION,
        PROPERTY_LISTING_CARD_FAVORITE_BUTTON_FAVORITE_ACTION,
        PROPERTY_MAP_CARD_FAVORITE_BUTTON_FAVORITE_ACTION,
    } from "../../mixins/FavoriteButtonMixin";
    import PropertyAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/PropertyAppResource";

    export {
        PROPERTY_DETAILS_FAVORITE_ACTION,
        PROPERTY_LISTING_CARD_FAVORITE_BUTTON_FAVORITE_ACTION,
        PROPERTY_MAP_CARD_FAVORITE_BUTTON_FAVORITE_ACTION
    };

    export default {
        name: "PropertyListingCardFavoriteButton",
        mixins: [GetPropertyInstanceMixin, FavoriteButtonMixin],
        props: {
            propertyAppResource: {
                type: Object,
                required: true,
                validator(value){
                    return value.constructor.name === (new PropertyAppResource()).constructor.name;
                }
            },
            hideOnBalloon: {
                type: Boolean,
                required: true,
            },
            displayButtonIconOnly: {
                type: Boolean,
                required: true,
            },
            favoriteOptionEnabled: {
                type: Boolean,
                default: true,
            }
        },

        data() {
            return {
                favorite: null,
                favoriteIsLoading: false,
            };
        },

        beforeMount() {
            this.$bus.$on(PROPERTY_LISTING_CARD_FAVORITE_BUTTON_FAVORITE_ACTION, this.handleChangeFavoriteEvent);
        },

        beforeDestroy() {
            this.$bus.$off(PROPERTY_LISTING_CARD_FAVORITE_BUTTON_FAVORITE_ACTION, this.handleChangeFavoriteEvent);
        },

        methods: {
            async handleChangeFavoriteEvent(isFavorite = null, propertyUuid = null) {
                if (propertyUuid === this.propertyAppResource._uuid) {
                    this.favorite = "boolean" === typeof(isFavorite) ? isFavorite : !this.favorite;
                }
            },
        },
    };
</script>
